import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import './styles/index.css';
import Home from './components/Home';
import reportWebVitals from './reportWebVitals';
const Epk = React.lazy(() => import('./components/Epk'));

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/epk",
    element: (
      <React.Suspense fallback={
        <div style={{ 
          background: '#122026', 
          minHeight: '100vh', 
          color: '#eae8df', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center', 
          fontFamily: 'var(--font-heading), sans-serif',
          fontSize: '1.25rem',
          letterSpacing: '0.1em',
          textTransform: 'uppercase'
        }}>
          Loading EPK...
        </div>
      }>
        <Epk />
      </React.Suspense>
    ),
  },
  {
    path: "*",
    element: <Home />,
  }
])


const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <div className='global'>
      <RouterProvider router={router} />
    </div>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
